import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { Box } from "@mui/material";
import type { FC } from "react";
import type { NurseInShift } from "../../../utils/models";
import { InnerBlock, type InnerBlockProps } from "./InnerBlock";

export type DraggableShiftData = {
	shiftId: string;
	nurseId: number;
	nurseInShift: NurseInShift;
	locationKey: string;
};

type Props = {
	nurseInShift: NurseInShift;
	locationKey: string;
} & InnerBlockProps;

export const DraggableShiftBlock: FC<Props> = ({ nurseInShift, locationKey, ...rest }) => {
	const draggableData: DraggableShiftData = {
		shiftId: nurseInShift.id,
		nurseId: nurseInShift.nurseId,
		nurseInShift,
		locationKey,
	};

	const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
		id: `shift-${nurseInShift.id}-${nurseInShift.nurseId}`,
		data: draggableData,
	});

	const style = {
		transform: transform ? CSS.Transform.toString({ ...transform, scaleY: 1 }) : undefined,
		zIndex: isDragging ? 10 : undefined,
		opacity: isDragging ? 0.8 : 1,
		width: "100%",
		cursor: isDragging ? "grabbing" : "grab",
	};

	return (
		<Box ref={setNodeRef} {...listeners} {...attributes} sx={style}>
			<InnerBlock {...rest} />
		</Box>
	);
};
